<script lang="ts">
  import type { AppController } from '../../app/controller.svelte';

  let { ctl }: { ctl: AppController } = $props();
  const s = $derived(ctl.stats);
  const t = $derived(ctl.transport);
</script>

<div class="hud" data-testid="hud" aria-live="off">
  {#if s}
    <div>
      <span>fps</span><b data-testid="hud-fps">{s.fps.toFixed(0)}</b> / {s.targetFps.toFixed(0)} @ {s.refreshHz}Hz
    </div>
    <div><span>cpu</span>{s.cpuMs.toFixed(2)} ms · pool {s.poolMB.toFixed(0)} MB</div>
    <div><span>quality</span>×{s.scale.toFixed(2)} · tier {s.tier} · {s.governor}</div>
    <div>
      <span>scene</span>{s.layers} layer{s.layers === 1 ? '' : 's'} · {s.modulations} mod · {s.transition}{s.outputs
        ? ` · ${s.outputs} out`
        : ''}
    </div>
    <div><span>predict</span>{s.predictMs.toFixed(0)} ms ahead</div>
    <div>
      <span>light</span>{(s.luminance * 100).toFixed(0)}% · limiter ×{s.flashGain.toFixed(2)}
    </div>
    <div>
      <span>level</span>{s.level.toFixed(2)} · frames <b data-testid="hud-frames">{s.frames}</b>
    </div>
  {:else}
    <div>waiting for renderer…</div>
  {/if}
  <div>
    <span>tempo</span><b data-testid="hud-bpm">{t.locked ? t.bpm.toFixed(1) : '—'}</b> ({t.source}, {(
      t.confidence * 100
    ).toFixed(0)}%)
  </div>
  <div><span>song</span>{ctl.mood.section} · energy {(ctl.mood.energy * 100).toFixed(0)}%</div>
  {#if ctl.renderer}
    <div class="renderer"><span>gpu</span>{ctl.renderer.mode} · {ctl.renderer.name}</div>
  {/if}
</div>

<style>
  .hud {
    position: absolute;
    top: 12px;
    left: 12px;
    z-index: 15;
    font-family: var(--mono);
    font-size: 11.5px;
    line-height: 1.6;
    padding: 8px 10px;
    border-radius: var(--radius-sm);
    background: rgba(0, 0, 0, 0.62);
    border: 1px solid var(--border);
    color: #cfcde0;
    pointer-events: none;
    max-width: min(460px, calc(100vw - 24px));
  }
  span {
    display: inline-block;
    width: 64px;
    color: var(--faint);
  }
  .renderer {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
